import React, { useState, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button,
    ButtonGroup,
    Form,
    CustomInput,
    FormGroup,
} from 'reactstrap';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Separator } from '../../../../../components/common/CustomBootstrap';
import Tooltip from './Tooltip';
export default function FacebookInfo({
    integration,
    integrationProperties,
    allProperties,
    saveIntegration
}) {
    const [formatedProperties, setFormatedProperties] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [list, setList] = useState([]);
    const [propertyList, setPropertyList] = useState([]);

    useEffect(() => {
        const result = (integrationProperties || [])
            .map(id => allProperties.find(elem => elem.id === id))
            .filter(Boolean);

        setFormatedProperties(result);
        setList(integrationProperties || []);

        const property = allProperties.map((elem) => {
            const isChecked = result?.some((r) => r?.id === elem.id);

            return {
                ...elem,
                checked: isChecked,
            };
        });

        setPropertyList(property);

    }, [integrationProperties, allProperties]);

    const handleCheckChange = (e) => {
        const values = propertyList.map((elem) => {
            if (elem.id === e.target.value) {
                elem.checked = !elem.checked;
            }
            return { ...elem };
        });

        setPropertyList(values);

        const propertyArr = values
            .filter((elem) => elem.checked === true)
            .map((elem) => elem.id);

        setList(propertyArr);
    };

    const handleSave = () => {
        saveIntegration({ list });

        const updated = propertyList
            .filter((p) => p.checked)
            .map((p) => p);

        setFormatedProperties(updated);

        setIsEditing(false);
    };
    const groupName = formatedProperties?.[0]?.groupName != null && formatedProperties?.[0]?.groupName != undefined ? formatedProperties[0].groupName : '';

    const EditView = () => {
        return (
            <CardBody>
                <div className="text-center">
                    <h6>Edit Properties</h6>
                    <Separator className="mb-3" />

                    <div className="text-left">
                        <h6>Properties</h6>

                        <Form>
                            <FormGroup>
                                <div className="integration-property">
                                    {propertyList.map((p, index) => (
                                        <CustomInput
                                            key={p.id}
                                            type="checkbox"
                                            id={index}
                                            label={p.name}
                                            value={p.id}
                                            checked={p.checked}
                                            onChange={handleCheckChange}
                                        />
                                    ))}
                                </div>
                            </FormGroup>
                        </Form>
                    </div>

                    <Separator className="my-2" />

                    <div style={{ marginTop: '20px' }}>
                        <Button color="primary" size="xs" onClick={handleSave}>
                            Save
                        </Button>

                        <Button
                            size="xs"
                            color="secondary"
                            className="ml-2"
                            onClick={() => setIsEditing(false)}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </CardBody>
        );
    };

    return (
        <Card className="mb-4">
            {isEditing ? (
                <EditView />
            ) : (
                <CardBody>
                    <div className="text-center">
                        <h6>
                            <IntlMessages id='integration.select_properties' />
                        </h6>
                        <Separator className="mb-3" />
                        <h1>{integration ? integration.name : null}</h1>

                        <div>
                            <h6>Integration</h6>
                            <div className="mb-2 container">
                                <b>{integration ? integration.name : null}</b>
                                <span className="text-muted pl-1">
                                    ({integration ? integration.id : null})
                                </span>
                            </div>
                        </div>

                        <div>
                            <h6>Group</h6>
                            <div className="mb-2 container">
                                <b>{groupName}</b>
                                <span className="text-muted pl-1">
                                    ({integration ? integration.groupId : null})
                                </span>
                            </div>
                        </div>

                        <div>
                            <h6>Properties</h6>
                            <div className="mb-2">
                                {formatedProperties?.map((elem, index) => (
                                    <div key={index} className="mb-2 container">
                                        <b>{elem?.name}</b>
                                        <span className="text-muted pl-1">
                                            ({elem?.id})
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div>
                            <h6>Phone number</h6>
                            <div className="mb-2 container">
                                <span className="text-muted pl-1">
                                    ({integration?.channelDetails?.phoneNumber})
                                </span>
                            </div>
                        </div>

                        <div style={{ marginTop: '20px', textAlign: 'center' }}>
                            <Button
                                size="xs"
                                color="success"
                                outline
                                style={{ display: 'inline-block', minWidth: '80px' }}
                                onClick={() => setIsEditing(true)}
                            >
                                Edit
                            </Button>
                        </div>
                    </div>
                </CardBody>
            )}
        </Card>
    );
}